import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import UsersSearch from '@sayyesschool/frontend/components/users-search';
import { useTeachers } from '@sayyesschool/frontend/features/teachers';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import TeacherForm from '@/components/teachers/teacher-form';
import TeachersTable from '@/components/teachers/teachers-table';

export default function TeachersPage({ history }) {
    const [teachers, actions] = useTeachers();

    const [teacher, setTeacher] = useState();
    const [isFormOpen, toggleFormOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const createTeacher = useCallback(data => {
        return actions.createTeacher(data)
            .finally(() => toggleFormOpen(false));
    }, [actions, toggleFormOpen]);

    const deleteTeacher = useCallback(() => {
        return actions.deleteTeacher(teacher.id)
            .finally(() => {
                setTeacher(null);
                toggleConfirmationDialogOpen(false);
            });
    }, [teacher, actions, toggleConfirmationDialogOpen]);

    const handleEdit = useCallback(teacher => {
        history.push(teacher.url, { edit: true });
    }, [history]);

    const handleDelete = useCallback(teacher => {
        setTeacher(teacher);
        toggleConfirmationDialogOpen(true);
    }, [toggleConfirmationDialogOpen]);

    if (!teachers) return <LoadingIndicator />;

    return (
        <Page>
            <Page.Header
                title="Преподаватели"
                actions={[{
                    key: 'add',
                    icon: 'add',
                    title: 'Создать',
                    onClick: toggleFormOpen
                }]}
            />

            <Page.Content>
                <UsersSearch params={{ role: 'teacher' }} />

                <Page.Section
                    variant="outlined"
                    compact
                >
                    <TeachersTable
                        teachers={teachers}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                </Page.Section>
            </Page.Content>

            <FormDialog
                form="teacher-form"
                title="Новый преподаватель"
                open={isFormOpen}
                onClose={toggleFormOpen}
            >
                <TeacherForm
                    id="teacher-form"
                    onSubmit={createTeacher}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Подтвердите действие"
                message={`Вы действительно хотите удалить клиента ${teacher?.fullname}?`}
                open={isConfirmationDialogOpen}
                onConfirm={deleteTeacher}
                onClose={toggleConfirmationDialogOpen}
            />
        </Page>
    );
}